import { gql } from '@apollo/client';

export interface CreateDirectRequestArgs {
  supplierUuid: string;
  requestUuid: string;
}

export const CREATE_DIRECT_REQUEST = gql`
  mutation createDirectRequest($supplierUuid: String!, $requestUuid: String!) {
    createDirectRequest(
      supplierUuid: $supplierUuid
      requestUuid: $requestUuid
    ) {
      uuid
    }
  }
`;
